var y;
(function(e) {
  e.Call = "call", e.Reply = "reply", e.Syn = "syn", e.SynAck = "synAck", e.Ack = "ack";
})(y || (y = {}));
var M;
(function(e) {
  e.Fulfilled = "fulfilled", e.Rejected = "rejected";
})(M || (M = {}));
var A;
(function(e) {
  e.ConnectionDestroyed = "ConnectionDestroyed", e.ConnectionTimeout = "ConnectionTimeout", e.NoIframeSrc = "NoIframeSrc";
})(A || (A = {}));
var k;
(function(e) {
  e.DataCloneError = "DataCloneError";
})(k || (k = {}));
var E;
(function(e) {
  e.Message = "message";
})(E || (E = {}));
const v = (e, n) => {
  const t = [];
  let o = !1;
  return {
    destroy(r) {
      o || (o = !0, n(`${e}: Destroying connection`), t.forEach((s) => {
        s(r);
      }));
    },
    onDestroy(r) {
      o ? r() : t.push(r);
    }
  };
}, D = (e) => (...n) => {
  e && console.log("[Penpal]", ...n);
}, O = {
  "http:": "80",
  "https:": "443"
}, _ = /^(https?:)?\/\/([^/:]+)?(:(\d+))?/, b = ["file:", "data:"], j = (e) => {
  if (e && b.find((i) => e.startsWith(i)))
    return "null";
  const n = document.location, t = _.exec(e);
  let o, r, s;
  t ? (o = t[1] ? t[1] : n.protocol, r = t[2], s = t[4]) : (o = n.protocol, r = n.hostname, s = n.port);
  const c = s && s !== O[o] ? `:${s}` : "";
  return `${o}//${r}${c}`;
}, N = ({ name: e, message: n, stack: t }) => ({
  name: e,
  message: n,
  stack: t
}), Y = (e) => {
  const n = new Error();
  return Object.keys(e).forEach((t) => n[t] = e[t]), n;
}, T = (e, n, t) => {
  const { localName: o, local: r, remote: s, originForSending: c, originForReceiving: i } = e;
  let d = !1;
  const u = (a) => {
    if (a.source !== s || a.data.penpal !== y.Call)
      return;
    if (i !== "*" && a.origin !== i) {
      t(`${o} received message from origin ${a.origin} which did not match expected origin ${i}`);
      return;
    }
    const p = a.data, { methodName: h, args: l, id: w } = p;
    t(`${o}: Received ${h}() call`);
    const S = (f) => (m) => {
      if (t(`${o}: Sending ${h}() reply`), d) {
        t(`${o}: Unable to send ${h}() reply due to destroyed connection`);
        return;
      }
      const C = {
        penpal: y.Reply,
        id: w,
        resolution: f,
        returnValue: m
      };
      f === M.Rejected && m instanceof Error && (C.returnValue = N(m), C.returnValueIsError = !0);
      try {
        s.postMessage(C, c);
      } catch (g) {
        if (g.name === k.DataCloneError) {
          const R = {
            penpal: y.Reply,
            id: w,
            resolution: M.Rejected,
            returnValue: N(g),
            returnValueIsError: !0
          };
          s.postMessage(R, c);
        }
        throw g;
      }
    };
    new Promise((f) => f(n[h].apply(n, l))).then(S(M.Fulfilled), S(M.Rejected));
  };
  return r.addEventListener(E.Message, u), () => {
    d = !0, r.removeEventListener(E.Message, u);
  };
};
let V = 0;
const z = () => ++V, L = ".", x = (e) => e ? e.split(L) : [], U = (e) => e.join(L), B = (e, n) => {
  const t = x(n || "");
  return t.push(e), U(t);
}, G = (e, n, t) => {
  const o = x(n);
  return o.reduce((r, s, c) => (typeof r[s] > "u" && (r[s] = {}), c === o.length - 1 && (r[s] = t), r[s]), e), e;
}, F = (e, n) => {
  const t = {};
  return Object.keys(e).forEach((o) => {
    const r = e[o], s = B(o, n);
    typeof r == "object" && Object.assign(t, F(r, s)), typeof r == "function" && (t[s] = r);
  }), t;
}, Q = (e) => {
  const n = {};
  for (const t in e)
    G(n, t, e[t]);
  return n;
}, H = (e, n, t, o, r) => {
  const { localName: s, local: c, remote: i, originForSending: d, originForReceiving: u } = n;
  let a = !1;
  r(`${s}: Connecting call sender`);
  const p = (l) => (...w) => {
    r(`${s}: Sending ${l}() call`);
    let S;
    try {
      i.closed && (S = !0);
    } catch {
      S = !0;
    }
    if (S && o(), a) {
      const f = new Error(`Unable to send ${l}() call due to destroyed connection`);
      throw f.code = A.ConnectionDestroyed, f;
    }
    return new Promise((f, m) => {
      const C = z(), g = ($) => {
        if ($.source !== i || $.data.penpal !== y.Reply || $.data.id !== C)
          return;
        if (u !== "*" && $.origin !== u) {
          r(`${s} received message from origin ${$.origin} which did not match expected origin ${u}`);
          return;
        }
        const I = $.data;
        r(`${s}: Received ${l}() reply`), c.removeEventListener(E.Message, g);
        let P = I.returnValue;
        I.returnValueIsError && (P = Y(P)), (I.resolution === M.Fulfilled ? f : m)(P);
      };
      c.addEventListener(E.Message, g);
      const R = {
        penpal: y.Call,
        id: C,
        methodName: l,
        args: w
      };
      i.postMessage(R, d);
    });
  }, h = t.reduce((l, w) => (l[w] = p(w), l), {});
  return Object.assign(e, Q(h)), () => {
    a = !0;
  };
}, W = (e, n, t, o, r) => {
  const { destroy: s, onDestroy: c } = o;
  let i, d;
  const u = {};
  return (a) => {
    if (n !== "*" && a.origin !== n) {
      r(`Parent: Handshake - Received ACK message from origin ${a.origin} which did not match expected origin ${n}`);
      return;
    }
    r("Parent: Handshake - Received ACK");
    const p = {
      localName: "Parent",
      local: window,
      remote: a.source,
      originForSending: t,
      originForReceiving: n
    };
    i && i(), i = T(p, e, r), c(i), d && d.forEach((l) => {
      delete u[l];
    }), d = a.data.methodNames;
    const h = H(u, p, d, s, r);
    return c(h), u;
  };
}, q = (e, n, t, o) => (r) => {
  if (!r.source)
    return;
  if (t !== "*" && r.origin !== t) {
    e(`Parent: Handshake - Received SYN message from origin ${r.origin} which did not match expected origin ${t}`);
    return;
  }
  e("Parent: Handshake - Received SYN, responding with SYN-ACK");
  const s = {
    penpal: y.SynAck,
    methodNames: Object.keys(n)
  };
  r.source.postMessage(s, o);
}, X = 6e4, J = (e, n) => {
  const { destroy: t, onDestroy: o } = n, r = setInterval(() => {
    e.isConnected || (clearInterval(r), t());
  }, X);
  o(() => {
    clearInterval(r);
  });
}, K = (e, n) => {
  let t;
  return e !== void 0 && (t = window.setTimeout(() => {
    const o = new Error(`Connection timed out after ${e}ms`);
    o.code = A.ConnectionTimeout, n(o);
  }, e)), () => {
    clearTimeout(t);
  };
}, Z = (e) => {
  if (!e.src && !e.srcdoc) {
    const n = new Error("Iframe must have src or srcdoc property defined.");
    throw n.code = A.NoIframeSrc, n;
  }
}, ee = (e) => {
  let { iframe: n, methods: t = {}, childOrigin: o, timeout: r, debug: s = !1 } = e;
  const c = D(s), i = v("Parent", c), { onDestroy: d, destroy: u } = i;
  o || (Z(n), o = j(n.src));
  const a = o === "null" ? "*" : o, p = F(t), h = q(c, p, o, a), l = W(p, o, a, i, c);
  return {
    promise: new Promise((S, f) => {
      const m = K(r, u), C = (g) => {
        if (!(g.source !== n.contentWindow || !g.data)) {
          if (g.data.penpal === y.Syn) {
            h(g);
            return;
          }
          if (g.data.penpal === y.Ack) {
            const R = l(g);
            R && (m(), S(R));
            return;
          }
        }
      };
      window.addEventListener(E.Message, C), c("Parent: Awaiting handshake"), J(n, i), d((g) => {
        window.removeEventListener(E.Message, C), g && f(g);
      });
    }),
    destroy() {
      u();
    }
  };
}, ne = (e, n, t, o) => {
  const { destroy: r, onDestroy: s } = t;
  return (c) => {
    if (!(e instanceof RegExp ? e.test(c.origin) : e === "*" || e === c.origin)) {
      o(`Child: Handshake - Received SYN-ACK from origin ${c.origin} which did not match expected origin ${e}`);
      return;
    }
    o("Child: Handshake - Received SYN-ACK, responding with ACK");
    const d = c.origin === "null" ? "*" : c.origin, u = {
      penpal: y.Ack,
      methodNames: Object.keys(n)
    };
    window.parent.postMessage(u, d);
    const a = {
      localName: "Child",
      local: window,
      remote: window.parent,
      originForSending: d,
      originForReceiving: c.origin
    }, p = T(a, n, o);
    s(p);
    const h = {}, l = H(h, a, c.data.methodNames, r, o);
    return s(l), h;
  };
}, te = () => {
  try {
    clearTimeout();
  } catch {
    return !1;
  }
  return !0;
}, oe = (e = {}) => {
  const { parentOrigin: n = "*", methods: t = {}, timeout: o, debug: r = !1 } = e, s = D(r), c = v("Child", s), { destroy: i, onDestroy: d } = c, u = F(t), a = ne(n, u, c, s), p = () => {
    s("Child: Handshake - Sending SYN");
    const l = { penpal: y.Syn }, w = n instanceof RegExp ? "*" : n;
    window.parent.postMessage(l, w);
  };
  return {
    promise: new Promise((l, w) => {
      const S = K(o, i), f = (m) => {
        if (te() && !(m.source !== parent || !m.data) && m.data.penpal === y.SynAck) {
          const C = a(m);
          C && (window.removeEventListener(E.Message, f), S(), l(C));
        }
      };
      window.addEventListener(E.Message, f), p(), d((m) => {
        window.removeEventListener(E.Message, f), m && w(m);
      });
    }),
    destroy() {
      i();
    }
  };
}, re = (e, n) => {
  let t = 0;
  const o = 10, r = 500;
  function s() {
    const c = document.getElementById(e);
    c ? ee({
      iframe: c,
      methods: {
        openCustom: n
      }
    }).promise.then((d) => {
      console.log("Connected to child window");
    }).catch((d) => {
      console.error("Error connecting to child window:", d);
    }) : (t++, t < o ? setTimeout(s, r) : console.error(
      `Failed to find iframe with id ${e} after ${o} attempts.`
    ));
  }
  s();
};
window.AllInOne = {
  $parent: null
};
function se() {
  oe({
    methods: {
      childFunction: () => {
      }
    }
  }).promise.then((n) => {
    window.AllInOne.$parent = n;
  }).catch((n) => {
    console.error("Error connecting to parent window:", n);
  });
}
function ce(e) {
  var n;
  return (n = window.AllInOne.$parent) == null ? void 0 : n.openCustom(e);
}
export {
  se as connectParent,
  re as on,
  ce as openCustom
};
